<div class="cim-datatable-wrapper">
  <table class="exp-table" [class.exp-table-sortable]="!sortDisabled">
    <thead>
      <tr>
        @for (col of visibleColumns; track col.id) {
          <th
            [class.num]="isNumericCol(col)"
            [class.asset]="isAssetCol(col)"
            [class.bold]="col.bold"
            [class.sortable]="!sortDisabled && col.type !== ColumnType.Input"
            [class.active]="sortKey === col.id"
            (click)="setSort(col)"
          >
            {{ col.label }}
            @if (sortKey === col.id) {
              <span class="sort-ind">{{ sortDir === "asc" ? "▲" : "▼" }}</span>
            }
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (row of displayRows; track $index) {
        <tr>
          @for (col of visibleColumns; track col.id) {
            @switch (col.type) {
              @case (ColumnType.Simple) {
                <td [class.bold]="col.bold">
                  {{ row[col.id] }}
                </td>
              }
              @case (ColumnType.Percentage) {
                <td class="num mono" [class.bold]="col.bold">
                  @if (row[col.id] !== null && row[col.id] !== 0) {
                    {{ row[col.id] * 100 | number: "1.2-2" }}%
                  } @else {
                    -
                  }
                </td>
              }
              @case (ColumnType.Number2Decimal) {
                <td class="num mono" [class.bold]="col.bold">
                  {{ row[col.id] | number: "1.0-2" }}
                  @if (col.suffix) {
                    <span>{{ col.suffix }}</span>
                  }
                </td>
              }
              @case (ColumnType.Input) {
                <td>
                  <mat-form-field class="cim-input-field" appearance="outline">
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="row[col.id]"
                      step="0.1"
                      [disabled]="inputDisabled"
                      (focus)="onInputFocus(row, col.id)"
                      (ngModelChange)="onInputChange()"
                    />
                    @if (col.suffix) {
                      <span matSuffix>{{ col.suffix }}</span>
                    }
                  </mat-form-field>
                </td>
              }
              @case (ColumnType.CompanyInfo) {
                <td class="asset">
                  @if (row.Ticker) {
                    <span class="ticker">{{ row.Ticker }}</span>
                  }
                  <span class="asset-link" (click)="onCompanyInfoClick(row)">{{
                    row[col.id]
                  }}</span>
                </td>
              }
              @case (ColumnType.NumberMin1Decimal) {
                <td class="num mono" [class.bold]="col.bold">
                  @if (isString(row[col.id])) {
                    {{ row[col.id] }}
                  } @else {
                    {{ row[col.id] | number: "1.0-2" }}
                  }
                  @if (col.suffix) {
                    <span>{{ col.suffix }}</span>
                  }
                </td>
              }
              @default {
                <td
                  [class.num]="isNumericCol(col)"
                  [class.asset]="isAssetCol(col)"
                >
                  {{ row[col.id] }}
                </td>
              }
            }
          }
        </tr>
      }

      @if (!displayRows.length) {
        <tr>
          <td [attr.colspan]="visibleColumns.length" class="empty-cell">
            No data available
          </td>
        </tr>
      }
    </tbody>

    @if (footer) {
      <tfoot>
        <tr>
          @for (col of visibleColumns; track col.id) {
            <td
              [class.num]="isNumericCol(col)"
              [class.asset]="isAssetCol(col)"
              [class.mono]="isNumericCol(col)"
              [class.bold]="true"
            >
              {{ footer[col.id] }}
            </td>
          }
        </tr>
      </tfoot>
    }
  </table>

  @if (needPaginator && totalPages > 1) {
    <div class="exp-pager">
      <span class="exp-pager-info"
        >Page {{ pageIndex + 1 }} of {{ totalPages }}</span
      >
      <button
        class="exp-pager-btn"
        type="button"
        [disabled]="pageIndex === 0"
        (click)="prevPage()"
      >
        ‹ Prev
      </button>
      <button
        class="exp-pager-btn"
        type="button"
        [disabled]="pageIndex >= totalPages - 1"
        (click)="nextPage()"
      >
        Next ›
      </button>
    </div>
  }
</div>
